import { Text } from '@zillow/constellation-10';

import { css, cx } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { TextPropsInterface } from '@zillow/constellation-10';

export const LoadingText = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  className,
  asChild,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & Omit<TextPropsInterface, 'ref'>) => (
  <Text
    data-loading={isLoading || null}
    // oxlint-disable-next-line constellation/no-classname-css-on-components -- must merge the computed shimmer css with the consumer's own className, which the css prop can't accept
    className={cx(
      css(shimmerStyles, cssProp, {
        _loading: { display: 'inline-block', marginTop: cssProp?.marginTop ?? 'micro.default' },
      }),
      className,
    )}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    {...(isLoading ? { ...rest } : { ...rest, asChild })}
  >
    {isLoading ? <span aria-hidden="true">&nbsp;</span> : children}
  </Text>
);
